import * as types from '../types';

export default {
  [types.GET_HOME_CUSTOM_TOTAL](state, data) {
    state.homeCustom = data;
  },
  [types.GET_HOME_BUSI](state, data) {
    state.homeBusi = data;
  },
  [types.GET_HOME_CONTRACT](state, data) {
    state.homeContract = data;
  },
  [types.GET_HOME_CUSTOM_VISIT](state, data) {
    state.homeCustomVisit = data;
  },
  [types.GET_HOME_CHART_DATA](state, data) {
    state.homeChartData = data;
  },
  [types.GET_HOME_PROJECT](state, data) {
    state.homeProject = data;
  },
  [types.GET_HOME_MEDICAL_CUSTOMER](state, data) {
    state.homeMedicalCustomer = data;
  },
};
